import { Navigate } from 'react-router-dom'
import { IToken } from './interfaces/IToken'
import jwtDecode from 'jwt-decode'
import { canAccessRouter } from './util/Functions'

const PrivateRoute = ({children}:any) => {

    let auth    = false
    const token = localStorage.getItem('us_tk') ?? ''

    if (token) {

        const decoded:IToken = jwtDecode(token)
        const now            = new Date()
      
        if (decoded && (decoded.exp * 1000) > now.getTime()) 
            auth = true
        else 
            localStorage.clear()
            
    }

    const menuActive:string[] = window.location.pathname.split('/')
    const curreRouter:string  = menuActive[1]

    if (!canAccessRouter(curreRouter)) 
        return <Navigate to="/dashboard" />
    
    return auth ? children : <Navigate to="/login" />
}

export default PrivateRoute